import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as projectReducer from "containers/Project/reducer";
import { getStep } from "containers/CreateWizard/reducer";

import AdvancedCosts from "components/CreateWizard/Costs/AdvancedCosts";
import AdvancedCostsOptimizer from "components/CreateWizard/Costs/Optimizer/AdvancedCosts";

class AdvancedCostsContainer extends React.PureComponent {
  render() {
    const { isOptimizer } = this.props;

    return isOptimizer ? <AdvancedCostsOptimizer {...this.props} /> : <AdvancedCosts {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateConversionGain: (conversionGain) => dispatch(setupReducer.updateConversionGain(ownProps.id, conversionGain)),
  updateConversionCost: (conversionCost) => dispatch(setupReducer.updateConversionCost(ownProps.id, conversionCost)),
  updateConversionMissed: (conversionMissed) =>
    dispatch(setupReducer.updateConversionMissed(ownProps.id, conversionMissed)),
  updateConversionSaved: (conversionSaved) =>
    dispatch(setupReducer.updateConversionSaved(ownProps.id, conversionSaved)),
  updateAdvancedRevenue: (advancedRevenue) =>
    dispatch(setupReducer.updateAdvancedRevenue(ownProps.id, advancedRevenue)),
  updateAdvancedCost: (advancedCost) => dispatch(setupReducer.updateAdvancedCost(ownProps.id, advancedCost)),
  updateTruePositive: (truePositive) => dispatch(setupReducer.updateTruePositive(ownProps.id, truePositive)),
  updateFalsePositive: (falsePositive) => dispatch(setupReducer.updateFalsePositive(ownProps.id, falsePositive)),
  updateTrueNegative: (trueNegative) => dispatch(setupReducer.updateTrueNegative(ownProps.id, trueNegative)),
  updateFalseNegative: (falseNegative) => dispatch(setupReducer.updateFalseNegative(ownProps.id, falseNegative)),

  updateOverestimateLabel: (overestimateLabel) =>
    dispatch(setupReducer.updateOverestimateLabel(ownProps.id, overestimateLabel)),
  updateUnderestimateLabel: (underestimateLabel) =>
    dispatch(setupReducer.updateUnderestimateLabel(ownProps.id, underestimateLabel)),

  updateFalseNegativeLabel: (falseNegativeLabel) =>
    dispatch(setupReducer.updateFalseNegativeLabel(ownProps.id, falseNegativeLabel)),
  updateFalsePositiveLabel: (falsePositiveLabel) =>
    dispatch(setupReducer.updateFalsePositiveLabel(ownProps.id, falsePositiveLabel)),
  updateTrueNegativeLabel: (trueNegativeLabel) =>
    dispatch(setupReducer.updateTrueNegativeLabel(ownProps.id, trueNegativeLabel)),
  updateTruePositiveLabel: (truePositiveLabel) =>
    dispatch(setupReducer.updateTruePositiveLabel(ownProps.id, truePositiveLabel)),
  updateAdvancedRevenueLabel: (advancedRevenueLabel) =>
    dispatch(setupReducer.updateAdvancedRevenueLabel(ownProps.id, advancedRevenueLabel)),
  updateAdvancedCostLabel: (advancedCostLabel) =>
    dispatch(setupReducer.updateAdvancedCostLabel(ownProps.id, advancedCostLabel)),
  updateNetImpactLabel: (netImpactLabel) => dispatch(setupReducer.updateNetImpactLabel(ownProps.id, netImpactLabel)),
  updateHideCosts: (hideCosts) => dispatch(setupReducer.updateHideCosts(ownProps.id, hideCosts)),
  updateCustomValue: (id, value) =>
    dispatch(setupReducer.updateCustomValue(ownProps.id, ownProps.blueprintId, id, value)),

  updateIsAdvanced: (isAdvanced) => dispatch(blueprintReducer.updateIsAdvanced(ownProps.blueprintId, isAdvanced)),
  updateCustomField: (customField, nextId) => {
    if (isNaN(ownProps.runId) && ownProps.runId !== "new") {
      dispatch(blueprintReducer.updateCustomField(ownProps.blueprintId, customField, nextId));
    } else {
      dispatch(setupReducer.updateCustomField(ownProps.runId, customField, nextId));
    }
  },
  updateCustomFieldById: (id, customField) => {
    if (isNaN(ownProps.runId) && ownProps.runId !== "new") {
      dispatch(blueprintReducer.updateCustomFieldById(ownProps.blueprintId, id, customField));
    } else {
      dispatch(setupReducer.updateCustomFieldById(ownProps.runId, id, customField));
    }
  },
  deleteCustomFieldById: (id) => {
    if (isNaN(ownProps.runId) && ownProps.runId !== "new") {
      dispatch(blueprintReducer.deleteCustomFieldById(ownProps.blueprintId, ownProps.id, id));
    } else {
      dispatch(setupReducer.deleteCustomFieldById(ownProps.runId, id));
    }
  },
  updateAdvancedInput: (id, evaluator, projectId) => {
    if (isNaN(ownProps.runId) && ownProps.runId !== "new") {
      dispatch(
        blueprintReducer.updateAdvancedInput(ownProps.blueprintId, id, evaluator, ownProps.runId || ownProps.id)
      );
    } else {
      dispatch(setupReducer.updateAdvancedInput(ownProps.runId, id, evaluator, ownProps.blueprintId));
    }

    if (projectId !== undefined) {
      dispatch(projectReducer.resetBudget(projectId));
    }
  },

  toggleCustomMapping: (customFieldId) =>
    dispatch(setupReducer.toggleCustomMapping(ownProps.id, ownProps.blueprintId, customFieldId)),
  setCustomMapping: (customFieldId, datasetColumn) =>
    dispatch(setupReducer.setCustomMapping(ownProps.id, ownProps.blueprintId, customFieldId, datasetColumn))
});

const mapStateToProps = (state, ownProps) => {
  const setupBlueprintId = ownProps.isAcademicResultsCard ? setupReducer.getBlueprintId(state, ownProps.id) : null;

  let customFields =
    ownProps.id === "new" || ownProps.blueprintId || ownProps.isAcademicResultsCard
      ? blueprintReducer.getCustomFieldsTransformed(state, ownProps.blueprintId)
      : blueprintReducer.getCustomFieldsTransformed(state, setupBlueprintId);
  let advancedInputs = blueprintReducer.getAdvancedInputs(state, ownProps.blueprintId);
  if (!isNaN(ownProps.runId) || ownProps.runId === "new") {
    const setupCFields = setupReducer.getCustomFieldsTransformed(state, ownProps.runId);
    const setupAInputs = setupReducer.getAdvancedInputs(state, ownProps.runId);
    if (Object.keys(setupCFields ?? {}).length) {
      customFields = setupCFields;
    }
    if (Object.keys(setupAInputs ?? {}).length) {
      advancedInputs = setupAInputs;
    }
  }

  return {
    conversionGain: setupReducer.getConversionGain(state, ownProps.id, false, true),
    conversionCost: setupReducer.getConversionCost(state, ownProps.id, false, true),
    conversionMissed: setupReducer.getConversionMissed(state, ownProps.id, false, true),
    conversionSaved: setupReducer.getConversionSaved(state, ownProps.id, false, true),
    advancedRevenue: setupReducer.getAdvancedRevenue(state, ownProps.id, true),
    advancedCost: setupReducer.getAdvancedCost(state, ownProps.id, true),
    truePositive: setupReducer.getTruePositive(state, ownProps.id),
    falsePositive: setupReducer.getFalsePositive(state, ownProps.id),
    trueNegative: setupReducer.getTrueNegative(state, ownProps.id),
    falseNegative: setupReducer.getFalseNegative(state, ownProps.id),

    setup: setupReducer.getSetup(state, ownProps.id),

    overestimateLabel: setupReducer.getOverestimateLabel(state, ownProps.id),
    underestimateLabel: setupReducer.getUnderestimateLabel(state, ownProps.id),

    truePositiveLabel: setupReducer.getTruePositiveLabel(state, ownProps.id),
    falsePositiveLabel: setupReducer.getFalsePositiveLabel(state, ownProps.id),
    trueNegativeLabel: setupReducer.getTrueNegativeLabel(state, ownProps.id),
    falseNegativeLabel: setupReducer.getFalseNegativeLabel(state, ownProps.id),
    advancedRevenueLabel: setupReducer.getAdvancedRevenueLabel(state, ownProps.id),
    advancedCostLabel: setupReducer.getAdvancedCostLabel(state, ownProps.id),

    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),

    currentROI: setupReducer.getCurrentROI(state, ownProps.id),

    hideCosts: setupReducer.getHideCosts(state, ownProps.id),

    outcome: setupReducer.getOutcomeFromDataset(state, ownProps.id),
    success: setupReducer.getSuccessValue(state, ownProps.id),
    successOptions: setupReducer.getSuccessOptions(state, ownProps.id),

    convergeError: setupReducer.getConvergeError(state, ownProps.id),
    priceColumn: setupReducer.getPriceColumn(state, ownProps.id),

    isContinuous:
      blueprintReducer.getOutcomeTypeFromBlueprint(state, ownProps.blueprintId) === "number" ||
      setupReducer.getOutcomeType(state, ownProps.id) === "number",
    customValues: setupReducer.getCustomValues(state, ownProps.id),

    isAdvanced: blueprintReducer.getIsAdvanced(state, setupBlueprintId ? setupBlueprintId : ownProps.blueprintId),
    customFields: customFields,
    customMappings: setupReducer.getCustomMappings(state, ownProps.id),
    customMappingOptions: setupReducer.getCustomMappingOptions(state, ownProps.id),

    advancedInputs: advancedInputs,

    isEditing:
      !ownProps.isAcademicResultsCard && blueprintReducer.getIsEditing(state, ownProps.blueprintId, ownProps.id),

    step: getStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AdvancedCostsContainer);
